import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  ParamMap,
  Router,
} from "@angular/router";
import { Location } from "@angular/common";
import { Subject, Subscription, forkJoin } from "rxjs";
import { AppService } from "src/app/app.service";
import { EmitterService } from "src/app/EmitterService";
import { Navbar } from "../navbar/navbar.component";

@Component({
  selector: "app-aside",
  templateUrl: "./aside.component.html",
  styleUrls: ["./aside.component.scss"],
})
export class AsideComponent {
  imageLoaded = false;
  current_main_route: any = "";
  
  cleanText(text: string): string {
    if (!text) return text;
    try {
      let txt = document.createElement('textarea');
      txt.innerHTML = text;
      let decoded = txt.value;
      return decoded.replace(/^[^a-zA-Z0-9\u0980-\u09FF]+/g, '').trim();
    } catch(e) {
      return text.replace(/^[^a-zA-Z0-9\u0980-\u09FF]+/g, '').trim();
    }
  }

  fetchinData = true;
  aside_data = test;
  subscription: Subscription;
  mainData: any;
  currentRoute: string;
  currentMenuItem: any;
  ContentData: any[] = [];
  allSubmenuItems: any;
  cuurent_menu_parent_name: any;
  currentContentData: any;
  private ngUnsubscribe = new Subject();
  @ViewChild(Navbar)
  childComponent: Navbar;
  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private appService: AppService,
    private router: Router,
    private emitterService: EmitterService
  ) { }
  ngOnInit() {
    this.FetchData();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
    // this.subscription.unsubscribe();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  FetchData() {
    // debugger;
    let mData = localStorage.getItem("mainData");

    if (mData != null) {
      this.mainData = JSON.parse(mData);
      this.currentRoute = "/" + this.route.snapshot.url.join("/");
      this.current_main_route = this.route.snapshot.url.join("/");

      let currentMenu = this.mainData.SiteMapList.filter(
        (item) => item.MenuUrl && (item.MenuUrl.trim() == this.currentRoute || item.MenuUrl.trim() == "/" + this.currentRoute || "/" + item.MenuUrl.trim() == this.currentRoute)
      );
      // All menu names
      if (currentMenu.length > 0) {
        let parentId = currentMenu[0].ParentId;

        // Filter SiteMapList to get all menu names with the same ParentId
        let filteredMenus = this.mainData.SiteMapList.filter(
          (item) => item.ParentId == parentId
        );

        // Extract MenuNames and MenuUrls from filteredMenus
        let menuDetails = filteredMenus.map((item) => {
          let name = item.DisplayNameBangla || item.MenuName;
          if (name) {
            name = this.cleanText(name);
          }
          
          return {
            MenuName: name,
            MenuUrl: item.MenuUrl,
          };
        });
        this.allSubmenuItems = menuDetails;
        console.log(menuDetails);
        
        this.cuurent_menu_parent_name = currentMenu[0];
        if (this.cuurent_menu_parent_name.DisplayNameBangla) {
          this.cuurent_menu_parent_name.DisplayNameBangla = this.cleanText(this.cuurent_menu_parent_name.DisplayNameBangla);
        }
        if (this.cuurent_menu_parent_name.DisplayName) {
          this.cuurent_menu_parent_name.DisplayName = this.cleanText(this.cuurent_menu_parent_name.DisplayName);
        }
        
        this.currentMenuItem = currentMenu[0];
      } else {
        console.log("Current menu not found.");
      }

      console.log(this.cuurent_menu_parent_name, "Current Menu");
    }
  }
}

let test = [
  {
    Id: 1391,
    ParentId: 0,
    MenuName: "Home",
    DisplayName: "Home",
    DisplayNameBangla: "হোম ",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 1,
  },
  {
    Id: 1392,
    ParentId: 0,
    MenuName: "About Us ",
    DisplayName: "About",
    DisplayNameBangla: "আমাদের সম্পর্কে",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 2,
  },
  {
    Id: 1393,
    ParentId: 0,
    MenuName: "Academic ",
    DisplayName: "Academic ",
    DisplayNameBangla: "পাঠ্যক্রম",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 3,
  },
  {
    Id: 1394,
    ParentId: 0,
    MenuName: "Admission ",
    DisplayName: "Admission ",
    DisplayNameBangla: "ভর্তি",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 4,
  },
  {
    Id: 1395,
    ParentId: 0,
    MenuName: "Administration",
    DisplayName: "Administration",
    DisplayNameBangla: "প্রশাসন",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 5,
  },
  {
    Id: 1399,
    ParentId: 0,
    MenuName: "Gallery ",
    DisplayName: "Gallery ",
    DisplayNameBangla: "গ্যালারি",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 9,
  },
  {
    Id: 1400,
    ParentId: 0,
    MenuName: "Contact ",
    DisplayName: "Contact ",
    DisplayNameBangla: "যোগাযোগ",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 10,
  },
  {
    Id: 1401,
    ParentId: 0,
    MenuName: "Login ",
    DisplayName: "Login ",
    DisplayNameBangla: "লগ-ইন",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 11,
  },
  {
    Id: 1405,
    ParentId: 0,
    MenuName: "Facilities ",
    DisplayName: "Facilities",
    DisplayNameBangla: "সুযোগ-সুবিধাসমূহ",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 15,
  },
  {
    Id: 1411,
    ParentId: 1392,
    MenuName: "At a Glance",
    DisplayName: "At a Glance",
    DisplayNameBangla: "এক নজরে ",
    MenuUrl: "/at-a-glance",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "About",
    DisplayNameParentBangla: "আমাদের সম্পর্কে",
    MenuOrder: null,
    MenuCode: 21,
  },
  {
    Id: 1412,
    ParentId: 1392,
    MenuName: "History",
    DisplayName: "History",
    DisplayNameBangla: "ইতিহাস",
    MenuUrl: "/history",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "About",
    DisplayNameParentBangla: "আমাদের সম্পর্কে",
    MenuOrder: null,
    MenuCode: 22,
  },
  {
    Id: 1413,
    ParentId: 1392,
    MenuName: "News And Events",
    DisplayName: "News & Events",
    DisplayNameBangla: "নিউস এন্ড ইভেন্টস ",
    MenuUrl: "/news-and-events",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 1,
    DisplayNameParent: "About",
    DisplayNameParentBangla: "আমাদের সম্পর্কে",
    MenuOrder: null,
    MenuCode: 23,
  },
  {
    Id: 1414,
    ParentId: 1392,
    MenuName: "Why Study ",
    DisplayName: "Why Study at MCPSC",
    DisplayNameBangla: "হোয়াই স্টাডি ",
    MenuUrl: "/why-study",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "About",
    DisplayNameParentBangla: "আমাদের সম্পর্কে",
    MenuOrder: null,
    MenuCode: 24,
  },
  {
    Id: 1416,
    ParentId: 1392,
    MenuName: "Mission",
    DisplayName: "Mission & Vision",
    DisplayNameBangla: "মিশন এবং ভিশন",
    MenuUrl: "/mission",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "About",
    DisplayNameParentBangla: "আমাদের সম্পর্কে",
    MenuOrder: null,
    MenuCode: 26,
  },
  {
    Id: 1417,
    ParentId: 1392,
    MenuName: "Achievements",
    DisplayName: "Achievements",
    DisplayNameBangla: "এচিভমেন্টস ",
    MenuUrl: "/achievements",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 1,
    DisplayNameParent: "About",
    DisplayNameParentBangla: "আমাদের সম্পর্কে",
    MenuOrder: null,
    MenuCode: 27,
  },
  {
    Id: 1419,
    ParentId: 1392,
    MenuName: "Infrastructure",
    DisplayName: "Infrastructure",
    DisplayNameBangla: "অবকাঠামো",
    MenuUrl: "/infrastructure",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "About",
    DisplayNameParentBangla: "আমাদের সম্পর্কে",
    MenuOrder: null,
    MenuCode: 29,
  },
  {
    Id: 1424,
    ParentId: 1393,
    MenuName: "Academic Calendar ",
    DisplayName: "Academic Calendar ",
    DisplayNameBangla: "শিক্ষা বর্ষপঞ্জি ",
    MenuUrl: "/academic-calendar",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Academic ",
    DisplayNameParentBangla: "পাঠ্যক্রম",
    MenuOrder: null,
    MenuCode: 34,
  },
  {
    Id: 1428,
    ParentId: 1393,
    MenuName: "Syllabus And Booklist",
    DisplayName: "Syllabus",
    DisplayNameBangla: "সিলেবাস",
    MenuUrl: "/syllabus-and-booklist",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Academic ",
    DisplayNameParentBangla: "পাঠ্যক্রম",
    MenuOrder: null,
    MenuCode: 38,
  },
  {
    Id: 1429,
    ParentId: 1393,
    MenuName: "Prospectus",
    DisplayName: "Prospectus",
    DisplayNameBangla: "প্রসপেক্টাস",
    MenuUrl: "/prospectus",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Academic ",
    DisplayNameParentBangla: "পাঠ্যক্রম",
    MenuOrder: null,
    MenuCode: 39,
  },
  {
    Id: 1441,
    ParentId: 1393,
    MenuName: "Club Activity",
    DisplayName: "Club",
    DisplayNameBangla: "ক্লাব",
    MenuUrl: "/club-activity",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "Academic ",
    DisplayNameParentBangla: "পাঠ্যক্রম",
    MenuOrder: null,
    MenuCode: 51,
  },
  {
    Id: 1442,
    ParentId: 1394,
    MenuName: "Admission Circular ",
    DisplayName: "Admission Circular ",
    DisplayNameBangla: "ভর্তি বিজ্ঞপ্তি ",
    MenuUrl: "/admission-circular",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Admission ",
    DisplayNameParentBangla: "ভর্তি",
    MenuOrder: null,
    MenuCode: 52,
  },
  {
    Id: 1446,
    ParentId: 1394,
    MenuName: "Admission Result",
    DisplayName: "Admission Result",
    DisplayNameBangla: "ভর্তির ফলাফল",
    MenuUrl: "/admission-result",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Admission ",
    DisplayNameParentBangla: "ভর্তি",
    MenuOrder: null,
    MenuCode: 56,
  },
  {
    Id: 1453,
    ParentId: 1395,
    MenuName: "Message Of Chief Patron",
    DisplayName: "Message Of Chief Patron",
    DisplayNameBangla: "প্রধান পৃষ্ঠপোষক বার্তা",
    MenuUrl: "/message-of-chief-patron",
    IsLeaf: true,
    FileType: 4,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 64,
  },
  {
    Id: 1454,
    ParentId: 1395,
    MenuName: "Message Of Chairman ",
    DisplayName: "Message Of Chairman ",
    DisplayNameBangla: "চেয়ারম্যানের বার্তা",
    MenuUrl: "/message-of-chairman",
    IsLeaf: true,
    FileType: 4,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 65,
  },
  {
    Id: 1456,
    ParentId: 1395,
    MenuName: "Message of Principal",
    DisplayName: "Message of Principal",
    DisplayNameBangla: "অধ্যক্ষের বার্তা",
    MenuUrl: "/message-of-principal",
    IsLeaf: true,
    FileType: 4,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 67,
  },
  {
    Id: 1457,
    ParentId: 1395,
    MenuName: "Message Of Vice Principal",
    DisplayName: "Message Of Vice Principal",
    DisplayNameBangla: "ভাইস প্রিন্সিপালের বার্তা",
    MenuUrl: "/message-of-vice-principal",
    IsLeaf: true,
    FileType: 4,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 68,
  },
  {
    Id: 1465,
    ParentId: 1395,
    MenuName: "Teacher Information",
    DisplayName: "Teachers",
    DisplayNameBangla: "শিক্ষকমন্ডলী",
    MenuUrl: "/teacher-information",
    IsLeaf: false,
    FileType: 5,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 76,
  },
  {
    Id: 1466,
    ParentId: 1395,
    MenuName: "Teacher's List (School) ",
    DisplayName: "School",
    DisplayNameBangla: "স্কুল ",
    MenuUrl: "/teacher's-list-(school)",
    IsLeaf: true,
    FileType: 5,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 77,
  },
  {
    Id: 1467,
    ParentId: 1395,
    MenuName: "Teacher's List (College)",
    DisplayName: "College",
    DisplayNameBangla: "কলেজ ",
    MenuUrl: "/teacher's-list-(college)",
    IsLeaf: true,
    FileType: 5,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 78,
  },
  {
    Id: 1470,
    ParentId: 1395,
    MenuName: "Staff Information",
    DisplayName: "Officers & Staffs",
    DisplayNameBangla: "কর্মচারীর তালিকা",
    MenuUrl: "/staff-information",
    IsLeaf: true,
    FileType: 6,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 81,
  },
  {
    Id: 1496,
    ParentId: 1399,
    MenuName: "Photo Gallery",
    DisplayName: "Photo Gallery",
    DisplayNameBangla: "ফটোস গ্যালারি ",
    MenuUrl: "/photo-gallery",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 3,
    DisplayNameParent: "Gallery ",
    DisplayNameParentBangla: "গ্যালারি",
    MenuOrder: null,
    MenuCode: 107,
  },
  {
    Id: 1497,
    ParentId: 1399,
    MenuName: "Video Gallery",
    DisplayName: "Video Gallery",
    DisplayNameBangla: "ভিডিওস গ্যালারি ",
    MenuUrl: "/video-gallery",
    IsLeaf: true,
    FileType: 2,
    LayoutType: 3,
    DisplayNameParent: "Gallery ",
    DisplayNameParentBangla: "গ্যালারি",
    MenuOrder: null,
    MenuCode: 108,
  },
  {
    Id: 1498,
    ParentId: 1401,
    MenuName: "Student's Login",
    DisplayName: "Students",
    DisplayNameBangla: "স্টুডেন্টস",
    MenuUrl: "/student's-login",
    IsLeaf: true,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "Login ",
    DisplayNameParentBangla: "লগ-ইন",
    MenuOrder: null,
    MenuCode: 109,
  },
  {
    Id: 1499,
    ParentId: 1401,
    MenuName: "Teacher's Login",
    DisplayName: "Teachers",
    DisplayNameBangla: "টিচারস",
    MenuUrl: "/teacher's-login",
    IsLeaf: true,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "Login ",
    DisplayNameParentBangla: "লগ-ইন",
    MenuOrder: null,
    MenuCode: 110,
  },
  {
    Id: 1507,
    ParentId: 1393,
    MenuName: "Class Routine",
    DisplayName: "Class Routine",
    DisplayNameBangla: "ক্লাস রুটিন",
    MenuUrl: "/class-routine",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Academic ",
    DisplayNameParentBangla: "পাঠ্যক্রম",
    MenuOrder: null,
    MenuCode: 118,
  },
  {
    Id: 1508,
    ParentId: 1393,
    MenuName: "Exam Routine",
    DisplayName: "Exam Routine",
    DisplayNameBangla: "পরীক্ষার রুটিন",
    MenuUrl: "/exam-routine",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Academic ",
    DisplayNameParentBangla: "পাঠ্যক্রম",
    MenuOrder: null,
    MenuCode: 119,
  },
  {
    Id: 1542,
    ParentId: 1405,
    MenuName: "Library",
    DisplayName: "Library",
    DisplayNameBangla: "পাঠাগার",
    MenuUrl: "/library",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "Facilities",
    DisplayNameParentBangla: "সুযোগ-সুবিধাসমূহ",
    MenuOrder: null,
    MenuCode: 153,
  },
  {
    Id: 1576,
    ParentId: 0,
    MenuName: "Welcome",
    DisplayName: "Welcome",
    DisplayNameBangla: "স্বাগত",
    MenuUrl: "#",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 187,
  },
  {
    Id: 1577,
    ParentId: 0,
    MenuName: "Notice",
    DisplayName: "Notice",
    DisplayNameBangla: "নোটিশ",
    MenuUrl: "#",
    IsLeaf: false,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "",
    DisplayNameParentBangla: "",
    MenuOrder: null,
    MenuCode: 188,
  },
  {
    Id: 1578,
    ParentId: 1395,
    MenuName: "Pre-Primary",
    DisplayName: "Pre-Primary",
    DisplayNameBangla: "প্রি-প্রাইমারি ",
    MenuUrl: "/pre-primary",
    IsLeaf: true,
    FileType: 5,
    LayoutType: 3,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 189,
  },
  {
    Id: 1579,
    ParentId: 1401,
    MenuName: "Guardian's Login",
    DisplayName: "Guardians",
    DisplayNameBangla: "গার্ডিয়ান্স ",
    MenuUrl: "/guardian's-login",
    IsLeaf: true,
    FileType: 0,
    LayoutType: 0,
    DisplayNameParent: "Login ",
    DisplayNameParentBangla: "লগ-ইন",
    MenuOrder: null,
    MenuCode: 190,
  },
  {
    Id: 1580,
    ParentId: 1395,
    MenuName: "Class Teacher",
    DisplayName: "Class Teacher",
    DisplayNameBangla: "শ্রেণী শিক্ষক ",
    MenuUrl: "/class-teacher",
    IsLeaf: true,
    FileType: 3,
    LayoutType: 1,
    DisplayNameParent: "Administration",
    DisplayNameParentBangla: "প্রশাসন",
    MenuOrder: null,
    MenuCode: 191,
  },
  {
    Id: 1581,
    ParentId: 1405,
    MenuName: "Canteen",
    DisplayName: "Canteen",
    DisplayNameBangla: "ক্যান্টিন ",
    MenuUrl: "/canteen",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "Facilities",
    DisplayNameParentBangla: "সুযোগ-সুবিধাসমূহ",
    MenuOrder: null,
    MenuCode: 192,
  },
  {
    Id: 1582,
    ParentId: 1405,
    MenuName: "Science Lab",
    DisplayName: "Science Lab",
    DisplayNameBangla: "সাইন্স ল্যাব ",
    MenuUrl: "/science-lab",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "Facilities",
    DisplayNameParentBangla: "সুযোগ-সুবিধাসমূহ",
    MenuOrder: null,
    MenuCode: 193,
  },
  {
    Id: 1583,
    ParentId: 1405,
    MenuName: "Computer Lab",
    DisplayName: "Computer Lab",
    DisplayNameBangla: "কম্পিউটার ল্যাব ",
    MenuUrl: "/computer-lab",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "Facilities",
    DisplayNameParentBangla: "সুযোগ-সুবিধাসমূহ",
    MenuOrder: null,
    MenuCode: 194,
  },
  {
    Id: 1584,
    ParentId: 1405,
    MenuName: "Class Room",
    DisplayName: "Class Rooms",
    DisplayNameBangla: "শ্রেণীকক্ষ ",
    MenuUrl: "/class-room",
    IsLeaf: true,
    FileType: 1,
    LayoutType: 2,
    DisplayNameParent: "Facilities",
    DisplayNameParentBangla: "সুযোগ-সুবিধাসমূহ",
    MenuOrder: null,
    MenuCode: 195,
  },
];
